import React from 'react'
import VisualCustomLineChartForChartCard2 from './VisualCustomerLineChartForChartCard2';
import {
  generateLaborSummary,
  getDailyScheduleHourRange,
  get_t_str,
} from '../../../../helpers/helpers';

function DailyChartCard2(props) {
  let data;
  let label1;
  let label2;
  if (props.earned_toggle) {
    label1 = "Earned";
    label2 = "Used";
    data = generateLaborSummary(
      props.calculated_earned_labor_day,
      props.actual_used_labor_vs_earned_day,
      get_t_str,
      label1,
      label2
    );
  } else {
    label1 = "Forecasted";
    label2 = "Scheduled";
    data = generateLaborSummary(
      props.forecasted_labor_day,
      props.actual_schedule_labor_day,
      get_t_str,
      label1,
      label2
    );
  }
  const { start_h, end_h } = getDailyScheduleHourRange(
    props.dow_default_operating_hours,
    props.day_operating_hours,
    props.actual_schedule,
    0,
    24,
    data.summary
  );

  return (
    <VisualCustomLineChartForChartCard2
      data={data.summary}
      roleTypes={data.roleTypes}
      date_name={props.date_name}
      height={112}
      grade={props.grade}
      hideHeader={props.hideHeader}
      isTable={false}
      label1={label1}
      label2={label2}
      index={props.index}
      windowWidth={props.windowWidth}
      forecasted_labor_day={props.forecasted_labor_day}
      actual_schedule_labor_day={props.actual_schedule_labor_day}
      calculated_earned_labor_day={props.calculated_earned_labor_day}
      actual_used_labor_vs_earned_day={props.actual_used_labor_vs_earned_day}
      agg_column={props.agg_column}
      earned_toggle={props.earned_toggle}
      start_h={start_h}
      end_h={end_h}
    />
  )
}

export default DailyChartCard2
